import React, {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../smallnation/partials'
import { CareerDirectory } from '../pages/careers/careerdirectory'
import { ExpiredCareers } from '../pages/careers/expiredcareers'
import { PendingCareers } from '../pages/careers/pendingcareers'
import { AddCompany } from '../pages/companydirectory/addcompany'
import { CompanyDirectory } from '../pages/companydirectory/companydirectory'
import { MergeCompany } from '../pages/companydirectory/mergecompany'
import { PendingCompanies } from '../pages/companydirectory/pendingcompanies'
import { Mergewithcompany } from '../pages/companydirectory/mergecompanies'
import { PromoteCompany } from '../pages/companydirectory/promotecompanies'


import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import { ExpiredProfiles } from '../pages/profiles/expiredprofiles'
import { PendingProfiles } from '../pages/profiles/pendingprofiles'
import { ProfileEdit } from '../pages/profiles/profileedit'
import { ProfileDirectory } from '../pages/profiles/profiledirectory'
//import { ConvertstudentResumes } from '../pages/students/convertstudentresume'
//import { Exploarationrequest } from '../pages/students/explorationrequest'
//import { SiteSchools } from '../pages/students/siteschools'
//import { StudentRegistration } from '../pages/students/studentregistration'
import { EventList } from '../pages/site/eventlist'
import { EditEvent } from '../pages/site/editevent'
import { CreateEvent } from '../pages/site/createevent'
import { CreateStudent } from '../pages/students/createstudent'
import { CreateProfile } from '../pages/profiles/createprofile'
import { CreateCompany } from '../pages/companydirectory/createcompany'
import { CreateJob } from '../pages/jobs/createjob'
import { CreateSchool } from '../pages/students/createSchool'
import { CreateIndustry } from '../pages/config/addindustry'
import { IndustryList } from '../pages/config/industrycategorylist'
import { EditIndustry } from '../pages/config/editindustry'
import { CreateJobseeker } from '../pages/students/createjobseeker'
import { JobLocationCountryList } from '../pages/config/joblocationcountrylist'
import { CreateJobLocation } from '../pages/config/addjoblocation'
import { EditJobLocation } from '../pages/config/editjoblocation'
import { CreateJobType } from '../pages/config/addjobtype'
import { JobTypeList } from '../pages/config/jobtypelist'
import { EditJobType } from '../pages/config/editjobtype'
import { CreateEducation } from '../pages/config/addeducation'
import { EducationList } from '../pages/config/educationlist'
import { EditEducation } from '../pages/config/editeducation'
import { SchoolList } from '../pages/students/schoolslist'
import { EditSchool } from '../pages/students/editschool'
import { EditStudent } from '../pages/students/editstudent'
import { StudentList } from '../pages/students/studentlist'
import { EditCompany } from '../pages/companydirectory/editcompany'
import { JobList } from '../pages/jobs/joblist'
import { DeleteSchool } from '../pages/students/deleteschool'
import { EditJob } from '../pages/jobs/editJob'
import { JobApplicationsList } from '../pages/jobs/jobapplications'
import { EditJobseeker } from '../pages/students/editjobseeker'
import { ViewJobApplication } from '../pages/jobs/viewJobApplication'
import { CreateUser } from '../pages/site/adduser'
import { UsersList } from '../pages/site/userslist'
//import { Login } from '../modules/auth/redux/AuthCRUD'
import { CreateCompanyUser } from '../pages/companydirectory/createcompanyuser'
import { EditCompanyUser } from '../pages/companydirectory/editcompanyuser'
import { CompanyDetails } from '../pages/companydirectory/companyDetails'
import { NotificationList } from '../pages/site/notificationlist'
import { EditNotification } from '../pages/site/editnotification'
import { AddNotification } from '../pages/site/addnotification'
import { WageData } from '../pages/jobs/wagedata'
import { PerksList } from '../pages/companydirectory/perkslist'
import { CompanyJobApplications } from '../pages/companydirectory/companyjobapplications'
import { CompanyVideoUpload } from '../pages/companydirectory/companyVideoUpload'
import { RepostJob } from '../pages/jobs/repostjob'

import { JobsReport } from '../pages/reports/jobsreport'
import { CompanyReport } from '../pages/reports/companyreport'
import { ProfileReport } from '../pages/reports/profilereport'
import { StudentReport } from '../pages/reports/studentreport'
 
export function PrivateRoutes() {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))



  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
          <Route path='/dashboard' component={DashboardWrapper} />
          {/* <Route path='/login' component={login} /> */}
          <Route path='/companydirectory' component={CompanyDirectory} />
          <Route path='/careerdirectory' component={CareerDirectory} />
          <Route path='/pendingcareer' component={PendingCareers} />
          <Route path='/expiredcareer' component={ExpiredCareers} />
          <Route path='/pendingcompany' component={PendingCompanies} />
          <Route path='/addcompany' component={AddCompany} />
          <Route path='/mergecompany' component={MergeCompany} />
          <Route path='/expiredprofile' component={ExpiredProfiles} />
          <Route path='/pendingprofile' component={PendingProfiles} />
          <Route path='/profileedit' component={ProfileEdit} />
          <Route path='/profiledirectory' component={ProfileDirectory} />
          <Route path='/eventlist' component={EventList} />
          <Route path='/notificationList' component={NotificationList} />
          <Route path='/editevent' component={EditEvent} />
          <Route path='/editNotification' component={EditNotification} />  
          <Route path='/AddNotification' component={AddNotification} />                    
          <Route path='/createevent' component={CreateEvent} />
          <Route path='/createprofile' component={CreateProfile} />
          <Route path='/createcompany' component={CreateCompany} />
          <Route path='/createjob' component={CreateJob} />
          <Route path='/editjob' component={EditJob} />
          <Route path='/wagedata' component={WageData} />
          <Route path='/viewJobApplication' component={ViewJobApplication} />
          <Route path='/mergewithcompany' component={Mergewithcompany} />
          <Route path='/managehomepagevideos' component={PromoteCompany} />
          

          {/* <Route path='/siteschools' component={SiteSchools} /> */}
          <Route path='/createstudent' component={CreateStudent} />
          <Route path='/createschool' component={CreateSchool} />
          {/* <Route path='/convertstresume' component={ConvertstudentResumes} /> */}
          {/* <Route path='/explorequest' component={Exploarationrequest} /> */}
          {/* <Route path='/studentregistartion' component={StudentRegistration} /> */}

          <Route path='/createindustry' component={CreateIndustry} />
          <Route path='/industrylist' component={IndustryList} />
          <Route path='/editindustry' component={EditIndustry} />
          <Route path='/createjobseeker' component={CreateJobseeker} />
          <Route path='/joblocationcountrylist' component={JobLocationCountryList} />
          <Route path='/createjoblocation' component={CreateJobLocation} />
          <Route path='/editjoblocation' component={EditJobLocation} />
          <Route path='/createjobtype' component={CreateJobType} />
          <Route path='/jobtypelist' component={JobTypeList} />
          <Route path='/editjobtype' component={EditJobType} />
          <Route path='/createeducation' component={CreateEducation} />
          <Route path='/educationlist' component={EducationList} />
          <Route path='/editeducation' component={EditEducation} />
          <Route path='/schoollist' component={SchoolList} />
          <Route path='/editschool' component={EditSchool} />
          <Route path='/editstudent' component={EditStudent} />
          <Route path='/studentlist' component={StudentList} />
          <Route path='/editcompany' component={EditCompany} />
          <Route path='/joblist' component={JobList} />
          <Route path='/deleteschool' component={DeleteSchool} />
          <Route path='/jobapplications' component={JobApplicationsList} />
          <Route path='/editjobseeker' component={EditJobseeker} />
          <Route path='/createuser' component={CreateUser} />
          <Route path='/userlist' component={UsersList} />
          <Route path='/addCompanyUser' component={CreateCompanyUser} />
          <Route path='/editCompanyUser' component={EditCompanyUser} />
          <Route path='/companyDetails' component={CompanyDetails} />
          
          <Route path='/perkslist' component={PerksList} />
          <Route path='/companyjobapplications' component={CompanyJobApplications} />
          <Route path='/companyVideoUpload' component={CompanyVideoUpload} />
          <Route path='/repostjob' component={RepostJob} />
          <Route path='/jobsreport' component={JobsReport} />
          <Route path='/companyreport' component={CompanyReport} />
          <Route path='/profilereport' component={ProfileReport} />
          <Route path='/studentreport' component={StudentReport} />

          {/* <Redirect from='/' to='/companydirectory' /> */}
          
          <Redirect from='/' to='/dashboard' />
          <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
